/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { useHistory } from "react-router-dom";
import { useState } from "react";
// import { getCookie } from "./constants";
import ErrorBoundary from "./ErrorBoundary";
import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAuthParams } from "./redux/actions/Auth/AuthParams";
import { resetSocialWallPersistScreenSettings } from "./redux/actions/SocialWallScreenSettings/SocialWallPersistScreenSettings";
const CommandCenter = React.lazy(() => import("./commandCenter"));
const Routes = () => {
  // const history = useHistory();
  const dispatch = useDispatch();
  // const [redirectPath, setredirectPath] = useState("/commandCenter");
  const redirectPath = "/commandCenter";
  const [path] = useState(window.location.pathname);
  const [flag, setFlag] = useState(false); //flag to show unauthorized user
  // auth
  const authParams = useSelector((state) => state?.AuthParams?.authParams);

  // let ptoken = getCookie("ptoken");
  // let user_id = getCookie("userid");

  var urlParams; // url encrypted parameters

  //Function to get url params from URL and set it to urlParams variable
  (window.onpopstate = function () {
    var match,
      pl = /\+/g, // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
      },
      query = window.location.search.substring(1);

    urlParams = {};
    while ((match = search.exec(query)))
      urlParams[decode(match[1])] = decode(match[2]);
  })();
  useEffect(() => {
    try {
      if (
        urlParams?.ptoken &&
        urlParams?.userid &&
        !(authParams?.ptoken && authParams?.userid)
      ) {
        let params = {
          ptoken: atob(urlParams?.ptoken),
          //ptoken: urlParams?.ptoken,
          userid: parseInt(urlParams?.userid),
          brand_id: urlParams?.brand_id
            ? urlParams?.brand_id?.split(",")?.[0]
            : [],
          theme_type: "1",
        };
        dispatch(setAuthParams(false, params));
      } else if (authParams?.ptoken && urlParams?.ptoken) {
        //iframe integrated in Angular tool
        let oldPtoken = authParams?.ptoken;
        let oldBrandId = authParams?.brand_id;
        let urlBrandId = urlParams?.brand_id
          ? urlParams?.brand_id?.split(",")?.[0]
          : [];
        if (oldPtoken) {
          if (
            oldPtoken !== atob(urlParams?.ptoken) ||
            oldBrandId !== urlBrandId
          ) {
            dispatch(resetSocialWallPersistScreenSettings());
            window.localStorage.clear();
          }
        }
        let params = {
          ptoken: atob(urlParams?.ptoken),
          //ptoken: urlParams?.ptoken,
          userid: parseInt(urlParams?.userid),
          brand_id: urlParams?.brand_id
            ? urlParams?.brand_id?.split(",")?.[0]
            : [],
          theme_type: "1",
        };
        dispatch(setAuthParams(false, params));
      }
    } catch (error) {
      console.error("Error occurred in authparams setting : ", error);
    }
  }, []);

  useEffect(() => {
    if (authParams?.ptoken && authParams?.userid) {
      setFlag(true);
    }
  }, [authParams]);
  return !flag ? (
    <div
      className="d-flex align-items-center"
      style={{
        justifyContent: "space-evenly",
        height: "calc(100vh - 40px)",
      }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <Switch>
      <Route path="/commandCenter">
        <Suspense
          fallback={
            <div
              className="d-flex align-items-center"
              style={{
                justifyContent: "space-evenly",
                height: "calc(100vh - 40px)",
              }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          }
        >
          <ErrorBoundary>
            <CommandCenter />
          </ErrorBoundary>
        </Suspense>
      </Route>
      <Route exact path={path}>
        <Redirect to={redirectPath} />
      </Route>
    </Switch>
  );
};

export default memo(Routes);
